import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link , useNavigate} from "react-router-dom";



const Policy = () => {

    const navigate = useNavigate();
    const [dataPolicy, setDataPolicy] = useState([]);

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/PolicyList/Get-GetPolicyDetailsAll', setDataPolicy);

    }, [dataPolicy]);

    const columns = [
        {
            name: "Title",
            selector: row => row.title,
            sortable: true,
            width: "200px"
        },
        {
            name: "Policy Details",
            selector: row => row.policyDetails,
            cell: (row) => (
                <div style={{ whiteSpace: "pre-line", width: "1350px" }} dangerouslySetInnerHTML={{ __html: row.policyDetails }} />
            ),
            allowOverflow: true,
            maxWidth:"600px",
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>

                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={`/addPolicy/`} onClick={(event) => onEditClick(event, row.id)}>
                        <img
                            src="/images/ImgEdit.ico" // Set the correct image source
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth:"200px",

        },
    ];

    const onStatusClick = async (id) =>{
        
        const confirmed = window.confirm("Are you sure you want to change Policy status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/PolicyList/Update-ChangePolicyStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                fetchData('https://igapi.heuristticminds.com/api/PolicyList/Get-GetPolicyDetailsAll', setDataPolicy);
            }
        }
        catch {
        }

    }

    const onEditClick = async (event, id) => {

        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/addPolicy/${id}`);
    }

    return(
        <>
            <Header />
        <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Policy' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Policy Details</div>
                                    <div className="card-body">
                                    <div className="row">
                                                <div className="col-sm-12">
                                                    <a href="/addPolicy" className="btn btn-primary"><i className="bi bi-plus-circle-fill"></i> Add Policy</a>
                                                </div>
                                            </div>
                                    <div className="pb-2">
                                    
                                    <div className="ps-2 pe-2">
                                    <DataTable 
                                                columns={columns}
                                                data={dataPolicy}
                                            /> 
                                    </div>
   
                                    </div>
                                    </div>
                                    
                                    
                                    
                                
                            </div>

                        </div>
                    </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>

    )
}
export default Policy;